module.exports = "/img/about.c231dc28.png";